import CategoryNavigation from './CategoryNavigation.component';

export default CategoryNavigation;